const ctx = require.context('../iconfont/', true, /\.svg$/);
export default ctx.keys().reduce((acc, key) => {
    const moduleName = key.replace(/(.*\/)*([^.]+).svg/ig, '$2');
    if (!acc.has(moduleName)) {
        acc.set(moduleName, ctx(key).default);
    }
    return acc;
}, new Map());
